export default "__VITE_ASSET___J1xkfgq__"